import type { ColumnDef } from "@tanstack/react-table";

import type { HeadersData, TableColumnDefs, TableRow } from "../../../types";

import { ActionColumn } from "./ActionColumn";
import CheckValidColumn from "./CheckValidColumn";
import { SimpleCellTextColumn } from "./SimpleCellTextColumn";

const headerDataSimpleColumn = (headersData: HeadersData) => {
  return Object.entries(headersData).map(([key, value]) => {
    // NOTE: Never型だけはやめたいなぁ〜
    return SimpleCellTextColumn(`values.${key}` as never, {
      displayLabel: value?.value ?? "",
      sortable: false,
    }) as ColumnDef<TableRow>;
  });
};

export const createImportCsvColumns = (
  headersData: HeadersData = {},
): TableColumnDefs => {
  return [
    CheckValidColumn("isValid", {}),
    ...headerDataSimpleColumn(headersData),
    ActionColumn({}),
  ];
};
